import { getAllChildrenForItem } from "./getAllChildrenForItem";

import { MultiSelectOption } from ".";

/**
 * Helper function for handling selection change.
 * In a just world, this would be built into the MultiSelect
 *
 * @param currentState the currently selected elements e.g. selectedRoles
 * @param changed the element that changed e.g. role
 * @param stateFn the function for updating state e.g. setSelectedRoles
 * @param setSearchQueryStateFn the function for updating the search text state. Used to clear it everytime this is called.
 */
export function multiSelectSelectionChangeHandler<I extends string>(
  currentState: MultiSelectOption<I>[] = [],
  stateFn: (newState: MultiSelectOption<I>[]) => void,
  setSearchQueryStateFn?: React.Dispatch<React.SetStateAction<string>>,
  includeChildrenInSelection?: boolean
) {
  return (changed: MultiSelectOption<I>) => {
    if (includeChildrenInSelection) {
      const changedChildren = getAllChildrenForItem(changed);
      let newState = [...currentState];

      if (currentState.find((element) => element.id === changed.id)) {
        const idsToDelete = [
          changed.id,
          ...changedChildren.map(({ id }) => id),
        ];
        newState = newState.filter(
          (element) => !idsToDelete.includes(element.id)
        );
      } else {
        newState = [
          ...newState,
          { ...changed, children: [] },
          ...changedChildren,
        ];
      }
      stateFn(newState);
      setSearchQueryStateFn?.("");
      return;
    }

    if (currentState.find((a) => a.id === changed?.id)) {
      const newState = new Set([
        ...currentState.filter((r: MultiSelectOption) => r.id !== changed.id),
      ]);
      stateFn([...newState]);
    } else {
      stateFn([...currentState, changed]);
    }
    setSearchQueryStateFn?.("");
  };
}
